// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoadingSpinner_loader__EgkMa","spinner":"LoadingSpinner_spinner__WfEBf"};